<script>
    import Spinner from 'svelte-spinner';
    import { Tooltip } from 'sveltestrap';

    import { isDateInPast, isToday, isDateInFuture, isDateWithinFuturePeriod, isDateWithinPastPeriod } from '../../../date-time.js';

    import TriggerDate from './TriggerDate.svelte';

    export let id;
    export let triggerDates;
    export let pastDaysToAnalyse;
    export let futureDaysToAnalyse;
    export let displayDateOnly;

    $: displayedPreviousTriggerDates = !triggerDates ? null : triggerDates.filter(triggerDate => {
        if (isDateInPast(triggerDate.annualDate) && isDateWithinPastPeriod(triggerDate.annualDate, pastDaysToAnalyse)) {
            return true;
        }
    });

    $: displayedUpcomingTriggerDates = !triggerDates ? null : triggerDates.filter(triggerDate => {
        if (isDateInFuture(triggerDate.annualDate) && isDateWithinFuturePeriod(triggerDate.annualDate, futureDaysToAnalyse) 
                || isToday(triggerDate.annualDate)) {
            return true;
        }
    });

    $: hasDisplayedTriggerDates = ((displayedPreviousTriggerDates && displayedPreviousTriggerDates.length > 0)
        || (displayedUpcomingTriggerDates && displayedUpcomingTriggerDates.length > 0));


    $: checklistCompleted = triggerDates && (triggerDates.length > 1 || (triggerDates.length === 1 && triggerDates[0].category != 'E'));
</script>

<style>
    .trigger-dates-widget {
        display: flex;
        flex-direction: column;
    }

    .divider {
        border-top: 1px dashed #0267B3;
        margin-bottom: 4px
    }
    
    .no-records {
        padding: 5px;
        max-height: 50px;
        overflow: hidden;
    }

    #td-count-collapsed {
        display: inline-flex;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        background-color: #efefef;
        color: #0267B3;
        margin-left: 4px;
        cursor: default;
    }
</style>

<div class="trigger-dates-widget">
    {#if triggerDates}
        {#if hasDisplayedTriggerDates}
                        
            {#if displayedPreviousTriggerDates}
                {#each displayedPreviousTriggerDates as triggerDate, i}
                    <TriggerDate date={triggerDate.date} type={triggerDate.displayType} notes={triggerDate.notes}
                        annualDate={triggerDate.annualDate} previous={true} id={`${id}-previous-${i}`} {displayDateOnly} />
                {/each}
            {/if}

            {#if (displayedPreviousTriggerDates && displayedPreviousTriggerDates.length > 0) 
                    && (displayedUpcomingTriggerDates && displayedUpcomingTriggerDates.length > 0)}
                <div class="divider" />
            {/if}

            {#if displayedUpcomingTriggerDates}
                {#each displayedUpcomingTriggerDates as triggerDate, i}
                    <TriggerDate date={triggerDate.date} type={triggerDate.displayType} notes={triggerDate.notes}
                        annualDate={triggerDate.annualDate} upcoming={true} id={`${id}-upcoming-${i}`} {displayDateOnly} />
                {/each}
            {/if}   
        {:else}
            {#if !displayDateOnly}
                <span class="no-records">
                    {#if checklistCompleted}
                        No occurrences in the past {pastDaysToAnalyse} or upcoming {futureDaysToAnalyse} days
                    {:else}
                        Checklist not completed. Date of Birth added by default
                    {/if}
                </span>
            {:else}
                <span id="td-count-collapsed">{triggerDates ? triggerDates.length : 0}</span>
                <Tooltip target="td-count-collapsed" placement="bottom">
                    {#if checklistCompleted}
                        No trigger dates in the past {pastDaysToAnalyse} or upcoming {futureDaysToAnalyse} days
                    {:else}
                        Checklist not completed. Date of Birth added by default
                    {/if}
                </Tooltip>
            {/if}
        {/if}
    {:else}
        <div class="widget-spinner">
            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
        </div>
    {/if}
</div>  